import { Button, FormField, Pagination, Select, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
import { useRouter } from '../../../../router';
import { useStore } from '../../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../../resources/types';

const pageSize = 20;

export const MembersAccountsCasinoPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();
  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();


  const [movements, setMovements] = useState<any[]>([]);
  const [years, setYears] = useState<any[]>([]);
  const [year, setYear] = useState(0);
  const [balanceCasino, setBalanceCasino] = useState<number>(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const paginated = movements.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);




  useEffect(() => {
    //handleRefreshMovements();
    handleYears()
  }, []); //parameters.startDate, parameters.endDate, 
  useEffect(() => {
    //handleRefreshMovements();
    handleRefreshMovements()
  }, [year]); //parameters.startDate, parameters.endDate, 



  const handleYears = async () => {
    //if (parameters.startDate && parameters.endDate) { 

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/movements/casino/years',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({}),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0 && dataWeb.years) {
        setYears(dataWeb.years);
        if (dataWeb.years.length > 0) {
          setYear(dataWeb.years[0].value);
        }

      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (year > 0) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/movements/casino/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify({
            year: year,
            orderBy: "dateMovement",
            order: "desc",
          }),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        if (dataWeb.code == 0) {
          setMovements(dataWeb.movements);
          setBalanceCasino(dataWeb.balanceCasino);
        } else {
          addNotification(dataWeb.status, 'error', setData);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header
              description={<>Listado de movimientos de la cuenta casino para cargos y depósitos. Su saldo actual es de <strong>{formatCurrency(balanceCasino, "CLP")}</strong>.</>}
              actions={
                <SpaceBetween direction="horizontal" size="xs">

                  <Favorites />
                </SpaceBetween>
              }
            >
              Cartola cuenta casino
            </Header>
            {movements && (
              <Table
                filter={
                  years && years.length > 0 && (

                    <SpaceBetween direction="horizontal" size="xs">
                      <div style={{ width: 100 }}>
                        <FormField label="Filtro anual">

                          <Select
                            options={years}
                            selectedOption={years.find(y => y.value.toString() === year.toString()) || null}
                            onChange={({ detail }) => {
                              if (detail && detail.selectedOption.value !== "") {
                                setYear(Number(detail.selectedOption.value));
                              }
                            }}
                          />
                        </FormField>
                      </div>

                      <FormField label="&nbsp;">
                        <Button disabled={movements.length === 0} onClick={() => {
                          exportToExcel(movements, `cartola_casino_${year}.xlsx`);
                        }} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>


                      </FormField>
                    </SpaceBetween>
                  )}


                pagination={

                  <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                    {movements.length > parameters.pageSize && (
                      <Pagination
                        currentPageIndex={currentPageIndex}
                        pagesCount={Math.ceil(movements.length / parameters.pageSize)}
                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                      />
                    )}

                    {movements.length > 0 && movements.length > parameters.pageSize && (
                      <SelectPaging onSelect={(pageSize) => {
                        setCurrentPageIndex(1);
                        setParameters({ ...parameters, pageSize: pageSize });
                      }} />
                    )}
                  </SpaceBetween>
                }

                cellVerticalAlign='top'
                stickyHeader
                variant="embedded"
                columnDefinitions={[
                  {
                    id: "dateTransaction",
                    header: "Fecha",
                    width: 120,
                    cell: item => item.dateMovement
                  },
                  {
                    id: "data",
                    header: "Glosa",
                    cell: item => item.ammount > 0 ? "Abono Cta Casino desde Cta CPV" : "Pago Cta Socio a Casino"
                  },
                  {
                    id: "exp",
                    header: "Expiración",
                    cell: item => (
                      <FormField label={item.ammount > 0 ? item.dateExpires : ""}>
                        {item.ammount > 0 && item.isExpired === 0 ?
                          `Saldo: ${formatCurrency(item.balanceNonExpired, "CLP")}` : ""}
                      </FormField>

                    )
                  },
                  {
                    id: "ammount",
                    header: "Monto",
                    cell: item => item.ammount.toLocaleString('es-CL', {
                      style: 'currency',
                      currency: 'CLP',
                      maximumFractionDigits: 0
                    }),
                  },
                ]}
                items={paginated}
              />
            )}
          </SpaceBetween>
        </>
      }
    />
  );
};
